import "./qrcode-scan-modal.scss";
import { html, nothing, TemplateResult } from "lit";
import ComponentModal from "./component-modal";
import { Products } from "../assets/js/libs/api";
import { setCartItems } from "../webapps/shop/redux/actions";
import { Html5Qrcode } from "html5-qrcode";
import { state } from "lit/decorators";

class QrCodeScanModal extends ComponentModal {
  static get tagName(): string {
    return 'ncx-qrcode-scan-modal'
  }

  @state()
  html5QrcodeScanner: Html5Qrcode | null = null;

  @state()
  devices: any[] = [];

  constructor(resolve, reject) {
    super(resolve, reject);
    this.modalTitle = "Inquadra codice QR";
    this.fullScreen = true;
  }

  getCameras = async () => {
    this.devices = await Html5Qrcode.getCameras();
  }

  async connectedCallback(): void {
    super.connectedCallback();
    await this.getCameras();
    const cameraId = this.getCameraId();
    this.startScanning(cameraId);
  }

  get modalFooter(): TemplateResult<1> {
    return nothing;
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();
    this.stopScanning();
  }

  onSuccess = async (decodedText) => {
    // this.html5QrcodeScanner.clear();
    // handle the scanned code as you like, for example:
    console.log(`Code matched = ${decodedText}`);
    const rawItems: string = decodedText;
    const products = (await Products.GetList()).data;
    const items = rawItems.split(';').map((rawItem) => {
      const [pid, pqty, customizations] = rawItem.split('-');
      const product = products.find((p) => p.id == pid)
      if (product) {
        const item = { ...product };
        item.quantity = Number(pqty);
        if (customizations) {
          const rawCustomizationsArray = customizations.split(',');
          item.customizations = rawCustomizationsArray.map(customization => {
            const [cid, choices] = customization.split('_');
            return {
              customizationId: Number(cid),
              customizations: choices.split('.').map(choiceId => product.customizations.find(pc => pc.id == cid).choices.find(cc => cc.id == choiceId))
            }
          })
        } else {
          if (product.customizations)
            item.customizations = [];
        }
        return item;
      }
    })
    setCartItems(items);
    this.Hide();
  }

  stopScanning = () => {
    if (this.html5QrcodeScanner) {
      if (this.html5QrcodeScanner.isScanning)
        this.html5QrcodeScanner.stop();
      this.html5QrcodeScanner.clear();
    }
  }

  onError(error) {
    console.error(error);
  }

  startScanning(cameraId) {
    if (!cameraId) return;
    this.html5QrcodeScanner = new Html5Qrcode('reader');
    this.html5QrcodeScanner.start(cameraId, { fps: 10 }, this.onSuccess, this.onError);
  }

  onSelectCamera = (e) => {
    this.stopScanning();
    const cameraId = e.target.value;
    this.saveCameraId(cameraId);
    this.startScanning(cameraId);
  }

  saveCameraId = (cameraId) => {
    localStorage.setItem('cameraId', cameraId);
  }

  getCameraId = () => {
    return localStorage.getItem('cameraId');
  }

  isDeviceSelected = (deviceId, index) => {
    const savedCameraId = this.getCameraId();
    if (savedCameraId) {
      return savedCameraId === deviceId;
    } else {
      if (index === 0) {
        this.saveCameraId(deviceId);
        return true;
      }
    }
    return false;
  }

  get modalBody(): TemplateResult<1> {
    return html`
      <div class="mb-3">
        <select class="form-control" @change=${this.onSelectCamera}>
          ${this.devices.map((device, index) => html`
              <option 
                selected=${this.isDeviceSelected(device.id, index) || nothing} 
                value="${device.id}"
              >
                ${device.label}
              </option>
            `)}
        </select>
      </div>
      <div class="reader-wrapper">
        <div id="reader"></div>
      </div>
    `
  }
}
QrCodeScanModal.Register();
export default QrCodeScanModal;